import React from "react"
import ReactSelect, { components } from "react-select"
import clsx from "clsx"
import "./CustomSelect.scss"
import ChevronDown from "@components/icons/ChevronDown"

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDown />
    </components.DropdownIndicator>
  )
}

const CustomSelect = ({
  options,
  placeholder,
  className,
  value,
  onChange,
  menuIsOpen,
  ...props
}) => {
  const sortSelectStyles = {
    control: (provided) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
      "&:hover": {
        border: "none",
      },
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: "#555C65",
      transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#35373C",
      fontSize: "14px",
      lineHeight: "140%",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#35373C",
      fontSize: "14px",
      lineHeight: "140%",
    }),
  }
  return (
    <div className={clsx("react-select-wrap", className)}>
      <ReactSelect
        styles={sortSelectStyles}
        components={{
          // eslint-disable-next-line react/no-unstable-nested-components
          DropdownIndicator: (dropdownProps) => (
            <DropdownIndicator
              {...dropdownProps}
              className="dropdown-indicator"
            />
          ),
        }}
        options={options}
        value={value}
        onChange={onChange}
        isSearchable={false}
        placeholder={placeholder}
        className={clsx("react-select")}
        classNamePrefix="react-select"
        {...props}
        
        menuIsOpen={menuIsOpen}
      />
    </div>
  )
}

export default CustomSelect
